/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelsupport3Inputs */



/**
* | output |
* | --- |
* | "The Anchor" |
*
* @param {Personalityarchetypelabelsupport3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelsupport3 = /** @type {((inputs?: Personalityarchetypelabelsupport3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelsupport3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Anchor")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Ancla")
	return /** @type {LocalizedString} */ ("База")
});
export { personalityarchetypelabelsupport3 as "personalityArchetypeLabelSupport" }